import { SectionTitle } from '@sloyd/ui';
import { Wrapper } from './ContentTextures.style';

export type ContentTexturesProps = {};

export function ContentTextures(_props: ContentTexturesProps) {
  return (
    <Wrapper className='ContentTextures-wrapper' data-testid='ContentTextures-wrapper'>
      <SectionTitle gradient={{ from: '#43cea2', to: '#185a9d' }} title='🧵 Textures'>
        Add depth to your models with customizable <strong>textures</strong>.
      </SectionTitle>
    </Wrapper>
  );
}

export default ContentTextures;
